import {
    Avatar,
    Box,
    HStack,
    Progress,
    Text,
    VStack,
    Badge
} from "@chakra-ui/react";

import Card from "../../Dashboard/components/Card";



const ProfileSummary = ({
    driverPartner,
}) => {
    const user =
        driverPartner?.user;

    const fullName =
        [
            user?.first_name,
            user?.middle_name,
            user?.last_name,
        ]
            .filter(
                (value) =>
                    value?.trim()
            )
            .join(" ");

    const displayName =
        fullName ||
        user?.username ||
        "Driver Partner";

    const initials =
        displayName
            .split(" ")
            .map(
                (name) =>
                    name[0]
            )
            .join("")
            .slice(0, 2)
            .toUpperCase();

    const profileImage =
        driverPartner?.documents?.find(
            (
                document
            ) =>
                document.document_type ===
                "Profile Image"
        );

    const API_URL =
        process.env.REACT_APP_API_BASE_URL?.replace(
            /\/$/,
            ""
        );

    const profileImageUrl =
        profileImage?.file_path
            ? `${API_URL}/${profileImage.file_path.replace(
                  /^\//,
                  ""
              )}`
            : null;

    const joinedDate =
        driverPartner?.created_at
            ? new Date(
                  driverPartner.created_at
              ).toLocaleDateString(
                  "en-US",
                  {
                      month:
                          "long",
                      year:
                          "numeric",
                  }
              )
            : "-";
    const requiredFields = [
    user?.first_name,
    user?.last_name,
    user?.phone_number,
    user?.email,
    user?.district,
    user?.village,
    user?.physical_address,
    user?.postal_address,
    user?.id_or_passport_number,
];

const completedFields =
    requiredFields.filter(
        (field) =>
            field &&
            String(field).trim() !== ""
    ).length;

const profileCompletion =
    Math.round(
        (completedFields /
            requiredFields.length) *
            100
    );
    return (
        <Card>
            <HStack
                align="flex-start"
                spacing={5}
            >
                <Avatar.Root
                    size="2xl"
                    borderRadius="16px"
                     objectFit="cover"
                >
                    <Avatar.Image
                        borderRadius="16px"
                        src={
                            profileImageUrl
                        }
                    />

                    <Avatar.Fallback
                        bg="#2453FF"
                        color="white"
                        fontWeight="700"
                    >
                        {initials}
                    </Avatar.Fallback>
                </Avatar.Root>

                <VStack
                    align="stretch"
                    flex="1"
                    gap={3}
                >
                    <HStack
                        justify="space-between"
                        flexWrap="wrap"
                    >
                        <Box>
                            <Text
                                fontSize="2xl"
                                fontWeight="700"
                                color="#071D54"
                            >
                                {
                                    displayName
                                }
                            </Text>

                            <Text
                                mt={1}
                                color="gray.500"
                                fontSize="sm"
                            >
                                Partner ID:
                                {" "}
                                {
                                    driverPartner?.partner_referral_code
                                }
                                {" • "}
                                Joined
                                {" "}
                                {
                                    joinedDate
                                }
                            </Text>
                        </Box>

                        <Badge
                            colorPalette={
                                driverPartner?.status ===
                                "Approved"
                                    ? "green"
                                    : driverPartner?.status ===
                                    "Pending"
                                    ? "yellow"
                                    : driverPartner?.status ===
                                    "Rejected"
                                    ? "red"
                                    : "gray"
                            }
                            px={4}
                            py={2}
                            borderRadius="full"
                            fontWeight="600"
                        >
                            {driverPartner?.status ||
                                "Unknown"}
                        </Badge>
                                            </HStack>

                    <Box pt={2}>
                        <HStack
                            justify="space-between"
                            mb={2}
                        >
                            <Text
                                fontSize="sm"
                                color="gray.500"
                            >
                                Profile
                                Completion
                            </Text>

                            <Text
                                fontSize="sm"
                                color="#2453FF"
                                fontWeight="700"
                            >
                                    {profileCompletion}%
                            </Text>
                        </HStack>

                       <Progress.Root
                            value={
                                profileCompletion
                            }
                            size="sm"
                            borderRadius="full"
                        >
                            <Progress.Track bg="#E8EEFF">
                                <Progress.Range bg="#2453FF" />
                            </Progress.Track>
                        </Progress.Root>
                    </Box>
                </VStack>
            </HStack>
        </Card>
    );
};

export default ProfileSummary;